import { render } from "./TopicFlipCard.vue?vue&type=template&id=3a11b002&scoped=true"
import script from "./TopicFlipCard.vue?vue&type=script&lang=js"
export * from "./TopicFlipCard.vue?vue&type=script&lang=js"

import "./TopicFlipCard.vue?vue&type=style&index=0&id=3a11b002&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a11b002"]])

export default __exports__